(function () {

  // ✅ Business day yok: düz takvim günü ekle
  function addDays(startDate, days) {
    const d = new Date(startDate);
    d.setDate(d.getDate() + Number(days || 0));
    return d;
  }

  function formatDate(d, locale) {
    return d.toLocaleDateString(locale || undefined, {
      weekday: "short",
      month: "short",
      day: "numeric"
    });
  }

  function clampRange(min, max) {
    const mi = Math.max(1, Number(min) || 1);
    const ma = Math.max(mi, Number(max) || mi);
    return [mi, ma];
  }

  function findVariantIdInput(initialVariantId) {
    const inputs = document.querySelectorAll('input[name="id"]');
    if (!inputs.length) return null;
    const exact = Array.from(inputs).find(i => String(i.value) === String(initialVariantId));
    return exact || inputs[0];
  }

  function updateUI(sectionEl, data, variantId) {
    const v = data.variants[String(variantId)] || data.variants[String(data.initial_variant_id)];
    if (!v) return;

    const locale = data.locale || undefined;
    const card = sectionEl.querySelector('[data-role="fs-card"]') || sectionEl;

    // Out of stock => hide card
    if (!v.delivery_available) {
      card.style.display = "none";
      return;
    } else {
      card.style.display = "";
    }

    const [min, max] = clampRange(v.delivery_min || 1, v.delivery_max || 3);

    // Estimated delivery: düz takvim günü
    const d1 = addDays(new Date(), min);
    const d2 = addDays(new Date(), max);

    const deliveryRangeEl = sectionEl.querySelector('[data-role="delivery-range"]');
    if (deliveryRangeEl) deliveryRangeEl.textContent = `${formatDate(d1, locale)} – ${formatDate(d2, locale)}`;

    // Online text
    const onlineEl = sectionEl.querySelector('[data-role="online-text"]');
    if (onlineEl) onlineEl.innerHTML = `Delivery or pickup in <strong>${min}–${max} days</strong>`;

    // Pickup row elements
    const pickupRow = sectionEl.querySelector('[data-role="pickup-row"]');
    const pickupTitleEl = sectionEl.querySelector('[data-role="pickup-title"]');
    const pickupTextEl = sectionEl.querySelector('[data-role="pickup-text"]');

    if (!v.pickup_supported) {
      if (pickupRow) pickupRow.style.display = "none";
    } else {
      if (pickupRow) pickupRow.style.display = "";
    }

    // KURAL: min <= 6 ise pickup today olabilir (stok varsa)
    const isFast = min <= 6;
    const showPickupToday = isFast && v.pickup_available;

    // In-store range
    let instoreMin = min;
    let instoreMax = max;
    if (showPickupToday) {
      [instoreMin, instoreMax] = clampRange(min - 2, max - 2);
    }

    // In-store text (gün aralığı yok)
    const instoreEl = sectionEl.querySelector('[data-role="instore-text"]');
    if (instoreEl) {
      const sameDayPart = showPickupToday ? "<strong>same-day</strong> when available" : "when available";
      instoreEl.innerHTML = `Express delivery ${sameDayPart}`;
    }

    const addr = data.store_address || "Store";
    const url = data.contact_url || "/pages/contact-page";

    // Pickup behavior
    if (showPickupToday) {
      if (pickupTitleEl) pickupTitleEl.textContent = "Pickup Today";
      if (pickupTextEl) {
        pickupTextEl.innerHTML =
          `<a class="FurnitureSpotDelivery__link" href="${url}" target="_blank" rel="noopener">${addr}</a>`;
      }
    } else {
      const p1 = addDays(new Date(), instoreMin);
      const p2 = addDays(new Date(), instoreMax);

      if (pickupTitleEl) pickupTitleEl.textContent = "Pickup";
      if (pickupTextEl) {
        pickupTextEl.innerHTML =
          `Pickup ready: <strong>${formatDate(p1, locale)} – ${formatDate(p2, locale)}</strong><br>` +
          `<a class="FurnitureSpotDelivery__link" href="${url}" target="_blank" rel="noopener">${addr}</a>`;
      }
    }
  }

  function initOne(sectionEl) {
    const jsonEl = sectionEl.querySelector('script[type="application/json"]');
    if (!jsonEl) return;

    let data;
    try { data = JSON.parse(jsonEl.textContent); } catch (e) { return; }

    const variantInput = findVariantIdInput(data.initial_variant_id);
    if (!variantInput) return;

    updateUI(sectionEl, data, variantInput.value);

    const obs = new MutationObserver(() => updateUI(sectionEl, data, variantInput.value));
    obs.observe(variantInput, { attributes: true, attributeFilter: ["value"] });

    document.addEventListener("change", () => updateUI(sectionEl, data, variantInput.value));
  }

  function init() {
    document.querySelectorAll(".FurnitureSpotDelivery").forEach(initOne);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();